import { createContext } from 'react';

/** Lets a header menu open the Saved views dialog held by PersonalViewBoundary. Null outside a menu placement. */
export const SavedViewsContext = createContext<{ open: () => void } | null>(null);
